import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { fetchInvoiceGroupsBySoldToAddressIds } from '../queries/fetch-invoice-groups-by-sold-to-address-ids';

interface UseFetchInvoiceGroupBySoldToAddressQueryVariables {
  soldToAddressIds: string[];
}

export const useFetchInvoiceGroupBySoldToAddressQuery = ({
  soldToAddressIds,
}: UseFetchInvoiceGroupBySoldToAddressQueryVariables) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);
  return usePersistedCacheQuery<
    generatedTypesNew.FetchInvoiceGroupsBySoldToAddressIdsQuery,
    generatedTypesNew.FetchInvoiceGroupsBySoldToAddressIdsQueryVariables
  >(fetchInvoiceGroupsBySoldToAddressIds, {
    variables: {
      ids: soldToAddressIds,
    },
    skip: !soldToAddressIds || !soldToAddressIds.length,
    client: ansClient,
  });
};
